<mat-card class="full-height-container">
  <mat-card-content class="full-height-container content-panel">
    <div class="flex-row">
      <app-component-header (refreshClickEvent)="this.refreshView()"
                            [checkAutoRefreshByDefault]="false"
                            [hideColumnsButton]="true"
                            [hideUploadButton]="true"
                            [startRefreshTimer]="this.refreshComplete"
                            [subtitleSegments]="getUrlSegments()"
                            class="full-width">
        <ag-mode-switch [initialMode]="this.currentMode" (newMode)="switchMode($event)"></ag-mode-switch>
      </app-component-header>
    </div>
    <div class="flex-row table-container">
      <ag-kpi-sidebar [sidebar]="kpiSidebar" class="mg-r-s">
        <div kpi-footer class="flex-centered pd-t-s pd-b-s">
          <ag-time-scale-picker [initialScaleValue]="this.scale" (selectionChange)="onScaleChanged($event)"></ag-time-scale-picker>
        </div>
      </ag-kpi-sidebar>
      <ag-grid-angular
        (columnVisible)="onColumnVisible($event)"
        (filterChanged)="onFilterChanged($event)"
        (firstDataRendered)="onFirstDataRendered($event)"
        (gridReady)="onGridReady($event)"
        (viewportChanged)="onViewportChanged($event)"
        [columnDefs]="tableColumns"
        [gridOptions]="baseAgGridOptions"
        [groupHideOpenParents]="false"
        [overlayNoRowsTemplate]="noRowsTemplate"
        [rowData]="rowData"
        [rowGroupPanelShow]="'always'"
        [style.display]="this.isDataMode() ? 'block' : 'none'"
        [suppressPropertyNamesCheck]="true"
        class="ag-theme-quartz ag-grid-flex">
      </ag-grid-angular>
      <div *ngIf="!this.isDataMode()" class="flex-row chart-container">
        <div *ngIf="this.isGridGrouped()" class="data-type-selection">
          <mat-button-toggle-group (change)="onDataTypeChange($event.value)" [(ngModel)]="selectedDataType"
                                   aria-label="Select Data Type">
            <mat-button-toggle *ngFor="let dataType of dataTypeOptions" [value]="dataType.value">
              {{ dataType.label }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <ag-charts [options]="chartOptions" class="chart"></ag-charts>
      </div>
    </div>
  </mat-card-content>
</mat-card>
